import { GoalNotSucceededError } from './GoalNotSucceedError';

export class PlanningGoalNotSucceededError extends GoalNotSucceededError {
  public constructor(message: string = '') {
    super(message);
  }
}
